// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"d8492a80","274":"87a006b6","337":"d98be8d4","353":"25162ce5","453":"08501e96","504":"2fe7a10e","729":"f5cb60d2"}[chunkId] + ".chunk.js";
};